/**
 * @flow
**/

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Booking from './';
import CloseButton from '../../../Components/CloseButton';
import { Row, Col } from 'reactstrap';
import { translate  } from 'react-i18next';
import Flight from '../../../Store/Flight';

type Props = {
  flight: Flight,
  booking: BookingRequest,
  onBook: (bookingRequest: BookingRequest) => void,
  onClose: () => void,
}

@observer
export class Mobile extends Component {

  props: Props;

  render() {

    const { flight, booking, onBook, t } = this.props;

    return (
      <div className="mobile-booking">
        <Row>
          <Col>
            <div className="float-right">
              <CloseButton onClick={this.props.onClose} />
            </div>
            <h2>{t('{{flight.name}} buchen', { flight: { name: flight.aircraft_offer.flight_offer.title } })}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Booking flight={flight} booking={booking} onBook={onBook} fullscreen={true} />
          </Col>
        </Row>
      </div>
    )
  }
}

export default translate ()(Mobile);



// WEBPACK FOOTER //
// ./src/App/Flight/View/Booking/Mobile.js